var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-empty-wrapper"},[_c('a-empty',{attrs:{"image":_vm.simpleImage},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }